module.exports = __webpack_public_path__ + "static/img/zixun.2f2d709b.png";